import { useContext } from 'react';
import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { ConfigContext } from '@/context';
import { Views, type ViewValues } from '@/constants';

type PrivacyOptionsProps = {
  loading: boolean;
  setSelectedView: (view: ViewValues) => void;
};

export function PrivacyOptions({
  loading,
  setSelectedView,
}: PrivacyOptionsProps) {
  const {
    privacyRequestsOptionsTitle,
    privacyRequestsDescription,
    privacyRequestsOptionsButtonText,
  } = useContext(ConfigContext);

  return (
    <Card loading={loading} title={privacyRequestsOptionsTitle}>
      <div className="grid grid-cols-1 gap-5">
        <p className="text-muted-foreground">{privacyRequestsDescription}</p>
        <div>
          <Button
            data-testid="cd-privacy-options-button"
            size="lg"
            variant="outline"
            onClick={() => setSelectedView(Views.PrivacyOptionsSelector)}
          >
            {privacyRequestsOptionsButtonText}
          </Button>
        </div>
      </div>
    </Card>
  );
}
